var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMarkaazLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 129,
    height: 33,
    viewBox: "0 0 129 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1374_19296)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M102.741 25.9459C101.394 24.2501 101.386 21.8489 102.656 20.0958L113.697 4.84593C114.054 4.35249 114.493 3.94418 114.981 3.62101C114.801 3.47853 114.617 3.3378 114.429 3.20228C106.681 -2.40632 95.7701 -0.470762 90.4551 7.60679C85.6736 14.8747 87.2842 24.7314 94.1299 30.1037C95.5529 31.2209 97.0941 32.0705 98.6978 32.663C101.038 33.5283 103.67 32.6787 105.133 30.658L106.244 29.1238C106.033 28.9882 105.827 28.8458 105.622 28.6981C104.515 27.8971 103.554 26.9693 102.743 25.9477L102.741 25.9459Z",
    fill: "url(#paint0_linear_1374_19296)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M123.258 5.32598C122.021 4.35647 120.683 3.61804 119.29 3.102C117.827 2.56165 116.235 2.79447 114.984 3.61977C116.029 4.4416 116.951 5.36421 117.745 6.36673C119.295 8.31792 119.305 11.0823 117.844 13.1012L106.245 29.1208C112.925 33.4593 121.972 31.6732 126.45 24.8692C130.604 18.5552 129.204 9.99112 123.258 5.32598Z",
    fill: "url(#paint1_linear_1374_19296)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M117.744 6.36805C116.948 5.36726 116.028 4.44466 114.983 3.62109C114.495 3.94253 114.056 4.35257 113.699 4.84602L102.658 20.0959C101.388 21.849 101.396 24.2502 102.743 25.946C103.552 26.9659 104.515 27.8937 105.622 28.6964C105.827 28.8441 106.034 28.9866 106.244 29.1221L117.843 13.1025C119.304 11.0836 119.296 8.32098 117.744 6.36805Z",
    fill: "url(#paint2_linear_1374_19296)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    style: {
      mixBlendMode: "multiply"
    },
    d: "M117.744 6.36805C116.948 5.36726 116.028 4.44466 114.983 3.62109C114.495 3.94253 114.056 4.35257 113.699 4.84602L102.658 20.0959C101.388 21.849 101.396 24.2502 102.743 25.946C103.552 26.9659 104.515 27.8937 105.622 28.6964C105.827 28.8441 106.034 28.9866 106.244 29.1221L117.843 13.1025C119.304 11.0836 119.296 8.32098 117.744 6.36805Z",
    fill: "url(#paint3_linear_1374_19296)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.29
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector_5",
    style: {
      mixBlendMode: "overlay"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M117.746 6.36903C116.95 5.36824 116.029 4.44564 114.985 3.62207C114.497 3.9435 114.057 4.35355 113.701 4.847L102.659 20.0969C101.389 21.85 101.398 24.2512 102.744 25.947C103.554 26.9669 104.517 27.8947 105.623 28.6974C105.828 28.8451 106.035 28.9876 106.245 29.1231L117.845 13.1035C119.306 11.0846 119.297 8.32196 117.746 6.36903Z",
    fill: "white"
  })))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M58.8163 13.0678C58.8163 10.5884 58.8145 8.10906 58.8197 5.63141C58.8197 5.17098 58.8076 4.70359 58.8823 4.25185C59.0699 3.1138 59.9786 2.3215 61.0142 2.33714C61.9767 2.35104 62.776 3.09121 62.9098 4.25358C63.014 5.16576 62.9723 6.09532 62.9775 7.01618C62.988 8.74498 62.9741 10.4755 62.9966 12.2043C62.9966 12.2095 62.9966 12.2165 62.9966 12.2217C63.0158 12.6908 63.6082 12.9462 63.954 12.6265L63.9592 12.6213C64.9669 11.6639 65.9121 10.6371 66.9494 9.71275C67.846 8.91178 68.6209 8.77625 69.3732 9.22973C70.2454 9.75619 70.5738 10.8682 70.2298 11.8082C70.0213 12.3781 68.018 14.3918 67.8077 14.6229C67.5089 14.9513 67.3334 15.363 67.3438 15.8113C67.3508 16.1258 67.4498 16.4368 67.6253 16.6992C67.8164 16.9859 68.0023 17.2795 68.1952 17.5679C68.6122 18.1899 69.024 18.8154 69.4271 19.4461C69.6651 19.818 69.8944 20.195 70.1307 20.5685C70.7354 21.5207 70.6589 22.7456 69.6182 23.4024C68.7164 23.9705 67.4029 23.6769 66.8139 22.8585C66.039 21.7813 65.3336 20.6485 64.5482 19.5764C64.5256 19.5452 64.5013 19.5174 64.4735 19.4896C64.0791 19.0899 63.3963 19.2376 63.1374 19.7363C63.0992 19.811 63.0644 19.8875 63.0383 19.9656C62.9324 20.2801 62.9932 20.6502 62.9775 20.996C62.8959 22.7943 62.2217 23.7586 61.0263 23.7846C59.6572 23.8142 58.8423 22.7543 58.8232 20.85C58.8024 18.8328 58.818 16.8138 58.8163 14.7966C58.8163 14.2198 58.8163 13.6429 58.8163 13.0678Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M49.062 9.49258C50.9055 10.019 50.8586 9.47346 52.2208 9.22848C53.6125 8.98002 55.2787 9.46999 56.4533 10.5472C57.2786 11.303 57.2056 12.5836 56.6096 13.2716C55.972 14.01 54.9243 14.1542 54.1911 13.7772C53.9843 13.6712 53.7706 13.5757 53.5569 13.4836C51.6352 12.6548 50.3721 13.4384 50.3113 15.5477C50.2644 17.2192 50.3061 18.8924 50.2922 20.5655C50.2887 21.0833 50.2974 21.6132 50.1844 22.1136C49.9586 23.1092 49.3539 23.806 48.2541 23.766C47.222 23.7278 46.5131 23.1527 46.2508 22.138C46.1656 21.8078 46.1431 21.4534 46.1413 21.1094C46.1344 17.9367 46.1153 14.7658 46.1465 11.5932C46.1604 10.1354 46.9684 8.89488 49.0568 9.49084L49.062 9.49258Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M43.6675 11.3936C43.5494 9.60399 42.1698 8.52849 40.7538 9.15572C39.6748 9.63353 38.7869 9.47194 37.7462 9.18352C32.8899 7.8335 28.5514 11.9461 28.4159 16.0535C28.2422 21.3841 33.3851 24.8417 37.7549 23.5716C38.4985 23.3544 39.3846 23.2363 40.1161 23.4204C42.3505 23.9869 43.6137 23.1894 43.7023 20.9046C43.7579 19.4659 43.7822 13.1172 43.6675 11.3953V11.3936ZM35.9879 19.7596C34.0975 19.7596 32.565 18.2271 32.565 16.3367C32.565 14.4464 34.0975 12.9139 35.9879 12.9139C37.8782 12.9139 39.4107 14.4464 39.4107 16.3367C39.4107 18.2271 37.8782 19.7596 35.9879 19.7596Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M86.4026 11.3936C86.2845 9.60399 84.9049 8.52849 83.4889 9.15572C82.4099 9.63353 81.522 9.47194 80.4813 9.18352C75.625 7.8335 71.2865 11.9461 71.151 16.0535C70.9773 21.3841 76.1202 24.8417 80.49 23.5716C81.2336 23.3544 82.1197 23.2363 82.8512 23.4204C85.0856 23.9869 86.3488 23.1894 86.4374 20.9046C86.493 19.4659 86.5173 13.1172 86.4026 11.3953V11.3936ZM78.723 19.7596C76.8326 19.7596 75.3001 18.2271 75.3001 16.3367C75.3001 14.4464 76.8326 12.9139 78.723 12.9139C80.6133 12.9139 82.1458 14.4464 82.1458 16.3367C82.1458 18.2271 80.6133 19.7596 78.723 19.7596Z",
    fill: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M26.0591 12.8211C25.6752 11.5927 24.935 10.4911 23.9255 9.68842C22.6467 8.67199 21.0187 8.19245 19.3959 8.20635C18.5341 8.2133 17.6741 8.3662 16.8626 8.65636C16.053 8.94652 15.3719 9.45907 14.6143 9.85174C14.4945 9.91429 14.3676 9.97163 14.2373 10.022C13.7334 10.2149 13.1722 10.1037 12.75 9.76834L12.7448 9.76487C11.466 8.74844 9.83801 8.2689 8.2152 8.2828C7.35341 8.28975 6.49335 8.44265 5.68195 8.73281C5.43002 8.82315 5.19024 8.93435 4.95742 9.05771C4.48656 9.30617 3.92362 9.24015 3.51531 8.89787C3.17303 8.61118 2.73344 8.43917 2.25216 8.43917H1.98806C0.896923 8.43917 0.0142822 9.32355 0.0142822 10.413V21.7344C0.0142822 22.8255 0.898661 23.7082 1.98806 23.7082H2.25216C3.3433 23.7082 4.22594 22.8238 4.22594 21.7344V15.0989C4.38058 13.947 5.00433 13.0591 6.13022 12.5327C7.30997 11.9802 8.71212 12.1748 9.72507 12.9844C10.7241 13.7819 11.0456 14.8887 11.0456 16.1171V21.5936C11.0456 22.4728 11.579 23.2877 12.4112 23.5726C13.2817 23.8715 14.114 23.6161 14.6526 23.0705C15.073 22.6848 15.3406 22.1323 15.3406 21.5172C15.3406 19.5278 15.3476 17.5366 15.3736 15.5472C15.3927 14.1381 16.0252 13.0609 17.3144 12.4562C18.4941 11.9037 19.8963 12.0983 20.9092 12.908C21.9083 13.7055 22.2297 14.8123 22.2297 16.0407V21.5172C22.2297 22.4155 22.7892 23.2408 23.6458 23.5136C25.1018 23.9775 26.4414 22.9037 26.4414 21.5172V17.8563C26.4414 16.1918 26.5682 14.43 26.0626 12.8211H26.0591Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M116.993 21.1492C116.878 20.065 115.879 19.2483 114.672 19.2483H113.025C112.477 19.2483 112.137 18.9547 112.001 18.6785C111.925 18.5238 111.833 18.2128 112.088 17.8757L116.453 12.1334C117.014 11.3949 117.007 10.4115 116.439 9.67656C116.02 9.05802 115.308 8.69141 114.526 8.69141H106.695C105.487 8.69141 104.49 9.50802 104.374 10.5922C104.313 11.1656 104.495 11.7251 104.891 12.1629C105.324 12.6442 105.958 12.9187 106.632 12.9187H108.617C109.087 12.9187 109.378 13.1689 109.494 13.4035C109.572 13.5598 109.623 13.8031 109.421 14.0672L104.876 20.0476C104.181 20.9615 104.313 22.1899 105.182 22.9092C105.487 23.1612 105.861 23.3314 106.268 23.4009C106.471 23.4513 106.66 23.4756 106.844 23.4756H114.738C115.412 23.4756 116.046 23.1994 116.479 22.7198C116.873 22.2803 117.057 21.7225 116.996 21.1492H116.993Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M102.722 11.3936C102.604 9.60399 101.225 8.52849 99.8087 9.15572C98.7297 9.63353 97.8419 9.47194 96.8011 9.18352C91.9449 7.8335 87.6064 11.9461 87.4708 16.0535C87.2971 21.3841 92.44 24.8417 96.8098 23.5716C97.5534 23.3544 98.4396 23.2363 99.171 23.4204C101.405 23.9869 102.669 23.1894 102.757 20.9046C102.813 19.4659 102.837 13.1172 102.722 11.3953V11.3936ZM95.0428 19.7596C93.1524 19.7596 91.6199 18.2271 91.6199 16.3367C91.6199 14.4464 93.1524 12.9139 95.0428 12.9139C96.9332 12.9139 98.4656 14.4464 98.4656 16.3367C98.4656 18.2271 96.9332 19.7596 95.0428 19.7596Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1374_19296",
    x1: 94.1369,
    y1: 7.64675,
    x2: 113.913,
    y2: 25.1762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#009BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00ADE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00BDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#00D2AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1374_19296",
    x1: 127.614,
    y1: 28.0349,
    x2: 108.802,
    y2: 12.2151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00D6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#00D3AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00CDB5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00C1C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00B1DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#009DF8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1374_19296",
    x1: 97.0108,
    y1: 4.4047,
    x2: 116.785,
    y2: 21.9359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0099FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#009BFB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#00A1F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#00ADE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#00BDCB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.98,
    stopColor: "#00D2AD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00D6A9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1374_19296",
    x1: 126.282,
    y1: 29.6173,
    x2: 107.469,
    y2: 13.7975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00D6A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#00D3AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#00CAB8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#00BDCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#00A9E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1374_19296"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 128.827,
    height: 33,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarkaazLogoWhite);
export default __webpack_public_path__ + "static/media/markaazLogoWhite.50ba78a0f814e4c4aaf67caf64b69ba8.svg";
export { ForwardRef as ReactComponent };